export const FIELD_SELECTOR = '.base-field';
const INVALID_CLASS = 'base-field_state_invalid';
const SUCCESS_CLASS = 'base-field_state_success';
const DATA_MESSAGE = 'data-message';

type FieldElement = HTMLElement | null;
export function showFieldError(element: FieldElement, error: string) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.setAttribute(DATA_MESSAGE, error);
    field.classList.add(INVALID_CLASS);
  }
}

export function showFieldSuccess(element: FieldElement, text: string) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.setAttribute(DATA_MESSAGE, text);
    field.classList.add(SUCCESS_CLASS);
  }
}

export function clearField(element: FieldElement) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.classList.remove(INVALID_CLASS);
    field.classList.remove(SUCCESS_CLASS);
    field.removeAttribute(DATA_MESSAGE);
  }
}
